module.exports = __webpack_public_path__ + "static/img/family-banner.0fa408a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/family-banner.jpg
// module id = dkkm
// module chunks = 21